export default {"src":"/_next/static/media/iconElephant.6b7923d8.svg","height":53,"width":50,"blurWidth":0,"blurHeight":0};